module.exports = "uniform sampler2D texture;\r\nuniform vec3 u_ambient;\r\nuniform vec3 u_lightPos;\r\nuniform vec3 u_lightCol;\r\nuniform float u_lightIntensity;\r\n\r\nvarying vec2 f_uv;\r\nvarying vec3 f_normal;\r\nvarying vec3 f_position;\r\n\r\nvoid main() {\r\n    float d = clamp(dot(f_normal, normalize(u_lightPos - f_position)), 0.0, 1.0);\r\n    gl_FragColor = vec4(d * u_lightCol * u_lightIntensity + u_ambient * 0.1, 1.0);\r\n    // gl_FragColor = vec4(f_normal, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./shaders/frag.glsl
// module id = 13
// module chunks = 0